import { Component, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IOperation, IOperationListColumnResponse, OperationsListRequest, IEditRowField, ReforecastRequest, IReforecastResponse } from '../../airport-interfaces';
import { AirportService } from '../../airport.service';
import { ScenarioService } from '../../../scenario-activities/scenario.service';
import { UserInfoService } from '../../../shared/user-info.service';
import { UserSession } from '../../../shared/user-session';
import { Button } from 'primeng/primeng';
import * as _ from 'lodash';
import { Dialog } from 'primeng/primeng';
import {Messages} from 'primeng/primeng';


import {SystemControl} from '../../../shared/system-control';
import {SystemControlElem} from '../../../shared/system-control-elem';
import { SystemControlService} from '../../../shared/system-control.service';
import {DecimalPipe} from '@angular/common';

@Component({
    selector: 'operations-reforecast',
    template: require('./operations-reforecast.component.html'),
    styles: [require('../../../styles/faa_styles.css')],
    directives: [Button]
})

export class OperationsReforecastComponent implements OnInit, OnDestroy{
    @Input() operation: IOperation;
    @Input() selected: boolean;
    @Input() locId: string;
    @Input() airportName: string;
    @Input() fieldName: string; 
    

    
    columns: IOperationListColumnResponse[];
    
    errorMessage: string;
    successMessage: string;

    systemControlElem: SystemControlElem;
    
    startYears:number[] = [];
    endYears:number[] = [];

    selectedStartYear: number;
    selectedEndYear: number;

    //not sure if this will be needed
    yearsToPreview: number = 4;
    

    forecastOperation: string;
    
    interpolationValue: number;
    fillInValue: number;
    growthRateValue: number;
    growAndSmoothValue: number;

    reforecastData: IReforecastResponse[];

    isScenarioOwner: boolean = false;

    averageRate: number;

    dataDisabled: boolean = true;
    growthDisabled: boolean = true;
    highlightYears: boolean = false; 
    displaySpinner :boolean=false;
    msgs: Messages[]=[];
    private sub: any; 
    ownScenarios:string ="true";

    constructor(private route: ActivatedRoute,
                private router: Router,
                private _airportService: AirportService,
                private _scenarioService: ScenarioService,
                private _userInfoService: UserInfoService, 
                private User: UserSession,
                private request: OperationsListRequest,
                private _systemControlService:SystemControlService) 
    {}

    ngOnInit(): void{

          this.sub = this.route.params.subscribe(
            params => {
                this.fieldName = params['fieldName'];
            }
          
        );
        if(this.selected){
            
            //will need to get columns in here for dropdown, only non calculated
            this.getColumns();
            this.getSystemControlValues();
        }
        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(
            success =>{ this.isScenarioOwner = success.isOwner; 
                if(this.isScenarioOwner == false && this.User.isAdmin == false){
                    this.ownScenarios="false";
                    this.msgs = [];
                    this.msgs.push({severity:'warn', summary:'Warn Message', detail:'We\'re sorry,  your access level does not permit you to view this page. Contact the TAF administrator to change your access privileges.'});
                }
            },
            error => this.errorMessage = <any>error
        );
         
       

    }

    getYears(){
        this.displaySpinner = true;
        let fieldNameSelected:string = (event.target as HTMLSelectElement).value;
        let params: ReforecastRequest = new ReforecastRequest;
        if(this.fieldName != fieldNameSelected && fieldNameSelected !=undefined){
            this.fieldName = fieldNameSelected
        }
        params.fieldName = this.fieldName ;
        params.locId = this.locId;
        params.tableName = this.operation.tableName;
        params.scenarioId = this.User.getSession().scenarioId;
        params.minYear = this.systemControlElem.ffcYear - this.yearsToPreview;
                
        this._airportService.getReforcastData(params)
            .subscribe(
                success => {
                    if(success.length > 0){
                        this.reforecastData = success;
                        
                        this.setLastYearsValues(this.reforecastData);
                        
                        this.reforecastData.map(data => {
                            data.originalValue = data.value;
                        });

                        this.reforecastData.map(data => {
                            data.growth = this.calcGrowthRate(data.value, data.lastYearsValue, 1);
                        });

                        this.reforecastData.map(data => {
                            data.originalGrowth = data.growth;
                        });

                        this.averageRate = this.calcGrowthRate(
                            //this.reforecastData[this.reforecastData.length-1].lastYearsValue,
                            this.reforecastData.find( data => { return data.aYear === this.systemControlElem.lfcYear }).value, 
                            this.reforecastData.find( data => { return data.aYear === this.systemControlElem.fyYear }).value,
                            this.systemControlElem.lfcYear - this.systemControlElem.fyYear);
                    }
                    this.displaySpinner = false;
                },
                error => this.errorMessage = <any>error
            );	
    }

    setLastYearsValues(dataIn: IReforecastResponse[]){

        for(let index in dataIn){
            
            if(+index === 0){
                dataIn[index].lastYearsValue = dataIn[index].value    
            }
            else{
                dataIn[index].lastYearsValue = dataIn[+index - 1].value
            }

        }
    }

    calcGrowthRate(last_value: number, first_value: number, num_years: number): number {
        
        let ret_val = 0;

        if (last_value > 0 && first_value > 0 && num_years > 0) {
            ret_val = (Math.exp((Math.log(last_value) - Math.log(first_value))/num_years) -1) * 100;
        }

        if(first_value == 0 && last_value > 0){
            ret_val = 999.99;
        }

        if(first_value > 0 && last_value == 0){
            ret_val = -999.99;
        }

        if (ret_val > 999.99) {
            ret_val = 999.99;
        }

        if (ret_val < -999.99) {
            ret_val = -999.99;
        }
        return (ret_val);
    }

    resetDataValues(){
        this.reforecastData.map(data => {
            data.value = data.originalValue;
        });
    }

    resetGrowthValues(){
        this.reforecastData.map(data => {
            data.growth = data.originalGrowth;
        });
    }

    getColumns(){
        this.request.tableName = this.operation.tableName;
        this.request.scenarioId = this.User.getSession().scenarioId;
        this.request.locId = this.locId;
        this.request.isAdmin = this.User.getSession().isAdmin ? 1 : 0;
        this._airportService.getOperationsColumns(this.request)
                .subscribe(
                    columns => {
                        this.columns = columns.filter(function(column){ return column.calculated == 0; });
                    },
                    error => this.errorMessage = <any>error);
    }
    
    getSystemControlValues(){
        this._systemControlService.getSystemControl()
            .subscribe(
                systemControlElem => {
                    this.systemControlElem = systemControlElem;
                    this.populateYears();
                    this.getYears();
                },
                error => this.errorMessage = <any>error);
    }

    populateYears(){
        this.populateStartYears();
        this.populateEndYears();
    }

    populateStartYears(){
    
        let index = 0;
        for(let year = this.systemControlElem.ffcYear; year <= this.systemControlElem.lfcYear; year++){
            this.startYears[index] = year;
            index++;
        }
        
        this.selectedStartYear = this.systemControlElem.ffcYear;
    }

    populateEndYears(){

        let index = 0;
        for(let year = this.systemControlElem.ffcYear - this.yearsToPreview; year <= this.systemControlElem.lfcYear; year++){
            this.endYears[index] = year;
            index++;
        }
        
        this.selectedEndYear = this.systemControlElem.lfcYear;
        
    }

    ngOnDestroy(){}

    radioSelected(event: any){
        if(!this.growthDisabled){
            this.resetGrowthValues();
            this.growthDisabled = true;
        }

       if(!this.dataDisabled){
            this.resetDataValues();
            this.dataDisabled = true;
        }

        this.dataDisabled = !(event.target.value === 'supplydata');
        this.growthDisabled = !(event.target.value === 'supplygrowth');
        this.highlightYears = !(event.target.value === 'supplygrowth' || event.target.value === 'supplydata');

    }


    formatGrowth(event: any, dataRow: IReforecastResponse, format: string){

        if(event.target.value === ""){
            event.target.value = 0
        }

        dataRow.growth = +(new DecimalPipe().transform(event.target.value, format)); 
    }

    formatData(event: any, dataRow: IReforecastResponse, format: string){
        if(event.target.value === ""){
            event.target.value = 0
        }

        dataRow.value = +(new DecimalPipe().transform(event.target.value, format)); 
    }
    calcDatasheet(dataRow: IReforecastResponse, type: string){
        let lastYr = this.systemControlElem.lfcYear;
        
        if(dataRow.value === dataRow.originalValue && dataRow.growth === dataRow.originalGrowth){
            return;
        }

        if (type === "data"){

            //drop the decimal part here
            dataRow.value = Math.floor(dataRow.value);

            let previousRow: IReforecastResponse = _.find(this.reforecastData, row => 
                { 
                    if(row.aYear == dataRow.aYear - 1){
                        return row;
                    } 
                });

            dataRow.growth = this.calcGrowthRate(dataRow.value, previousRow.value,  1)

            if(dataRow.aYear < lastYr){
                let nextRow: IReforecastResponse = _.find(this.reforecastData, row => 
                    { 
                        if(row.aYear == dataRow.aYear + 1){
                            return row;
                        } 
                    })

                nextRow.growth = this.calcGrowthRate( nextRow.value, dataRow.value, 1);

            }
        }
        else if (type === "growth"){

            let filteredRows = _.filter(this.reforecastData, data => { return data.aYear >= dataRow.aYear } );

            let first: boolean = true;

            for(let index in filteredRows){
                
                if(first){

                    let predRow: IReforecastResponse = _.find(this.reforecastData, data => { return data.aYear == filteredRows[index].aYear - 1; }); 

                    filteredRows[index].value = Math.floor(predRow.value +
                    (predRow.value * filteredRows[index].growth) / 100);
                    first = false;
                }
                else{
                    filteredRows[index].value = Math.floor(filteredRows[+index - 1].value +
                    (filteredRows[+index - 1].value * filteredRows[index].growth) / 100); 
                }

                if(filteredRows[index].value < 0){
                    filteredRows[index].value = 0;
                }
            }
        }
    }


    
    reset() {

        this.forecastOperation = null;

        this.resetDataValues();

        this.resetGrowthValues();

        this.dataDisabled = true;
        this.growthDisabled = true;
        this.highlightYears = false;
	}

    cancel(){
        let params = {
            locId: this.locId,
            airportName: this.airportName
        }

        this.router.navigate([`/operations-list/${this.operation.tableName}`, params]);
    }

    isValid(): boolean{

        if(!this.forecastOperation){
		    this.errorMessage = "Please choose an operation to perform!";
            return false;
        }


	    if (!(this.forecastOperation.substr(0,6) == "supply")) {
		    switch (this.forecastOperation) {
    			case "interpolate":
                {
		    		if(this.interpolationValue == null){
			    		this.errorMessage = "No value set for INTERPOLATE.\nPlease set a value for the selected method!";
				    	return false;
				    }

                    Math.floor(this.interpolationValue);
				    break;
                }
                case "fillinyears":
                {
                    if(this.fillInValue == null){
                        this.errorMessage = "No value set for FILLINYEARS.\nPlease set a value for the selected method!";
                        return false;
                    }
                    
                    Math.floor(this.fillInValue);
                    break;
                }
                case "growthrate":{
                    if(this.growthRateValue == null){
                        this.errorMessage = "No value set for GROWTH RATE.\nPlease set a value for the selected method!";
                        return false;
                    }
                    break;
                }
                case "growandsmooth":
                    if(this.growAndSmoothValue == null){
                        this.errorMessage = "No value set for GROW AND SMOOTH.\nPlease set a value for the selected method!";
                        return false;
                    }
                    break;
                default:
                    break;
            }

            if (this.selectedStartYear > this.selectedEndYear) {
                this.errorMessage = "Start Year cannot be greater than End Year!";
                return false;
            }
	    }
        return true;
    }
    
    save(){
        //console.log("save this.isValid()" + this.isValid());
        this.errorMessage = null;
        this.successMessage = null;

        if(this.isValid()){
            this.displaySpinner = true;
            if(this.forecastOperation === "supplydata" || this.forecastOperation === "supplygrowth"){

                //so need to send the years and the data list
                let params = {
                    tableName: this.operation.tableName,
                    locId: this.locId,
                    fieldName: this.fieldName,
                    ffcYear: this.selectedStartYear,
                    lfcYear: this.selectedEndYear,
                    values: this.reforecastData
                }
                this._airportService.reforecastSupplyData(params)
                    .subscribe(
                        response => {
                            if(response.responseStatus == "success"){
                                this.msgs=[];
                                this.msgs.push({severity:'info', summary:'Info Message', detail: 'Changes applied.' });
                                this.displaySpinner = false;
                                this.getYears();
                                //this.successMessage = "Changes saved!"
                            }
                            else if(response.responseStatus == "error"){
                                this.msgs=[];
                                this.msgs.push({severity:'error', summary:'Error Message', detail: 'An error occured while trying to save changes.' });
                                //this.errorMessage = "An error occured while trying to save changes.";
                                console.error(response.responseMessage);
                                this.displaySpinner = false;
                            }
                        },
                        error => {
                            this.msgs=[];
                            this.msgs.push({severity:'error', summary:'Error Message', detail: 'An error occured while trying to save changes.' });
                            //this.errorMessage = "An error occured while trying to save changes.";
                            console.error(error);
                            this.displaySpinner = false;
                        }
                    );
            }
            else if(this.forecastOperation === "interpolate"){
                this.callOperationService(this.interpolationValue);
	        }
            else if(this.forecastOperation === "fillinyears"){
                this.callOperationService(this.fillInValue);
            }
            else if(this.forecastOperation === "growthrate"){
                this.callOperationService(this.growthRateValue/100);
            }
            else if(this.forecastOperation === "growandsmooth"){
                this.callOperationService(this.growAndSmoothValue/100);
            }
            else{
                this.callOperationService();
                
            }
        }
    }

    private callOperationService(value?: number){
        this.displaySpinner = true;
       
        let params = {
            type: this.forecastOperation,
            startYear: this.selectedStartYear,
            endYear: this.selectedEndYear,
            value: value, 
            locId: this.locId,
            fieldName: this.fieldName,
            tableName: this.operation.tableName,
            scenario: this.User.getSession().scenarioId
        }
        this._airportService.reforecastOperation(params)
            .subscribe(
                response => {
                    if(response.responseStatus == "success"){
                        this.msgs=[];
                        this.msgs.push({severity:'info', summary:'Info Message', detail: 'Changes applied.' });
                        this.displaySpinner = false;
                        this.getYears();
                        //this.successMessage = 
                    }
                    else if(response.responseStatus == "error"){
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Error Message', detail: 'An error occured while trying to save changes.' });
                        //this.errorMessage = "";
                        this.displaySpinner = false;
                        console.error(response.responseMessage);
                    }
                },
                error => {
                    this.errorMessage = "An error occured while trying to save changes.";
                    this.msgs=[];
                    this.msgs.push({severity:'error', summary:'Error Message', detail: 'An error occured while trying to save changes.' });
                    console.error(error);
                    this.displaySpinner = false;
                }
            );
    }

    quickGraph(){
        let confirmAnswer = confirm("Warning:\n Please save your changes by clicking Apply Options before viewing the graph, or all changes will be lost and previous values will be graphed. ");

        if(confirmAnswer == true){
            //for some reason have to mask this
            let field = this.fieldName;
            let selectedColumns = _.filter(this.columns, function(column) { return column.fieldName === field; });
           
            sessionStorage.setItem('operations-graph-columns', JSON.stringify(selectedColumns));

            let params = {
                displayName: this.operation.displayName,
                locId: this.locId,
                airportName: this.airportName,
                graphType: 'line',
                startYear: this.selectedStartYear,
                endYear: this.selectedEndYear,
                quickGraph: "true"
            };

            this.router.navigate([`/operations-graph-display/${this.operation.tableName}`, params]);
        }
    }
    
}




/** WEBPACK FOOTER **
 ** ./app/airports/operations-lists/operations-reforecasts/operations-reforecast.component.ts
 **/